import { Component } from "react";
import { FaExclamationTriangle, FaRedo } from "react-icons/fa";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error?.message || "Erreur inconnue" };
  }

  componentDidCatch(error, info) {
    console.error("Application error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "40px",
            gap: "16px",
            minHeight: "200px",
          }}
        >
          <FaExclamationTriangle style={{ fontSize: "48px", color: "#e74c3c" }} />
          <h3 style={{ margin: 0, color: "#333" }}>Une erreur est survenue</h3>
          <p style={{ margin: 0, color: "#666", textAlign: "center", maxWidth: "500px" }}>
            Une erreur inattendue s'est produite. Vous pouvez réessayer ou recharger la page.
          </p>
          <p style={{ margin: 0, color: "#999", fontSize: "12px" }}>{this.state.errorMessage}</p>
          <button
            onClick={() => this.setState({ hasError: false, errorMessage: "" })}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "8px 16px",
              cursor: "pointer",
              borderRadius: "4px",
              border: "1px solid #ccc",
              background: "#fff",
            }}
          >
            <FaRedo />
            Réessayer
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
